<template>
  <div class="flex w-full h-screen overflow-auto">
    <div
      class="flex-1 flex flex-col justify-center items-center overflow-clip bg-cover bg-no-repeat bg-center bg-[url('@/assets/images/bg-img.png')]">
      <slot name="content"> </slot>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
